import classNames from 'classnames';

type Props = {
  text: string;
  textColor: string;
};

export default function Placeholder({ text, textColor }: Props) {
  return (
    <div className="flex justify-center items-center object-contain rounded-sm w-full h-full">
      <span className={classNames(textColor, 'text-xs font-semibold uppercase')}>{text}</span>
    </div>
  );
}
